import { render, staticRenderFns } from "./EditDevice.vue?vue&type=template&id=2cb763d8&"
import script from "./EditDevice.vue?vue&type=script&lang=js&"
export * from "./EditDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports